/**
 * Dropdown GUI component
 */

import { Select } from "@mantine/core";
import type { GuiDropdownElement } from "../types";
import { useWebSocket } from "../WebSocket";
import { useViewerStore } from "../store";

interface GuiDropdownProps {
  element: GuiDropdownElement;
}

export function GuiDropdown({ element }: GuiDropdownProps) {
  const { sendGuiEvent } = useWebSocket();
  const updateGuiValue = useViewerStore((state) => state.updateGuiValue);

  const handleChange = (value: string | null) => {
    if (value === null) return;

    // Update local state
    updateGuiValue(element.uuid, value);

    // Send to Python backend
    sendGuiEvent(element.uuid, "change", value);
  };

  return (
    <Select
      label={element.label}
      value={element.value}
      onChange={handleChange}
      data={element.options}
      disabled={element.disabled}
      size="sm"
      style={{ marginBottom: "12px" }}
    />
  );
}
